import React, { useState } from 'react'
import { SigmaCloudKeyResponseModel } from '@/domain/models'
import { useMediaQueries } from '@/presentation/hooks'
import { Box, Select } from '@/presentation/components'
import { useRecoilState, useRecoilValue } from 'recoil'
import { selectSigmaCloudKeyData } from './atom'
import { sigmaKeysState } from '../atom'

type SelectSigmaCloudKeyProps = {
  disabled?: boolean
}

export const SelectSigmaCloudKey: React.FC<SelectSigmaCloudKeyProps> = ({ disabled }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [currentKey, setCurrentKey] = useRecoilState(selectSigmaCloudKeyData)
  const keys = useRecoilValue(sigmaKeysState)
  const { isMobile } = useMediaQueries()

  const handleSelectCompany = (company: SigmaCloudKeyResponseModel): void => {
    setCurrentKey(company)
    setMenuOpen(false)
  }
  const handleOpen = (): void => {
    if (!disabled) {
      setMenuOpen(true)
    }
  }

  const getDescription = (): string => {
    if (!currentKey.empresaSigma) return 'Empresa - Chave/Particao'

    return `Empresa: ${currentKey.empresaSigma.toString()} - Chave: ${currentKey.chave}/${currentKey.particao}`
  }

  const customStyle = (): object => {
    if (isMobile) {
      return {
        margin: 'auto'
      }
    } else {
      return {
        marginLeft: 'auto'
      }
    }
  }

  return (
    <Box style={customStyle()}>
      <Select.Trigger
        label='Empresa - Chave/Particao'
        description={getDescription()}
        disabled={disabled}
        onOpen={handleOpen}
      />
      <Select.Modal
        title='Selecione a chave Sigma'
        isOpen={isMenuOpen}
        onClose={() => setMenuOpen(false)}
        items={keys.map((key) => ({
          id: key.idMonitoramento,
          descricao: `Empresa: ${key.empresaSigma.toString()} - Chave: ${key.chave}/${key.particao}`,
          data: key,
          isSelected: key.idMonitoramento === currentKey.idMonitoramento
        }))}
        onSelect={(_, key) => handleSelectCompany(key)}
      />
    </Box>
  )
}
